import { Box, CircularProgress, Container, Grid, Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { themePalette } from "../../config/theme.config";
import { useContext, useEffect, useState } from "react";
import IresearhService from "../../services/IresearchService";
import { HindexTop } from "../../Interface/IPersona";
import { useNavigate } from "react-router-dom";
import { I18nContext } from "../../I18nProvider";



export const HIndexTop: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const [datos, setDatos] = useState<HindexTop[]>([]);
    const [loading, setLoading] = useState<boolean>(true); 

    const navigate = useNavigate();

    

    const rows = datos.slice(0, 10).map((investigador) => ({
        id: investigador.scopusId,
        hindex: investigador.hindex,
        autor: investigador.nombreCompleto,
    }));

    const handleRowClick = (params: any) => {
        const { id } = params.row;
        navigate(`/investigador/${id}`);
    };


    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    const columns: GridColDef[] = [
        
        { field: "autor", headerName: context.t.translate("estadisticas.investigadores") , flex: 0.7, resizable: false },
        { field: "hindex", headerName: "Hindex", flex: 0.3, resizable: false },
    ];

    useEffect(() => {
        IresearhService.GetTopHindex()
            .then((response) => {

                const hindex: HindexTop[] = response.data.data
                setDatos(hindex)
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <Container>
            <h1>HIndex Top</h1>
            <Grid container justifyContent="center" alignItems="center">
                {loading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100px",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <Grid item xs={12} sm={8} md={8}>
                        <Paper elevation={3} style={{ width: "100%", height: 400 }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                disableRowSelectionOnClick
                                onRowClick={handleRowClick}
                                disableColumnMenu
                                hideFooter
                                sx={{
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "blue !important",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    },
                                    "& .MuiDataGrid-cell": {
                                        backgroundColor: "white",
                                        color: "black",
                                    },
                                    "& .MuiDataGrid-row:hover": {
                                        cursor: "pointer",
                                        backgroundColor: "#f5f5f5",
                                    },
                                }}
                            />
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </Container>
    );
};
